import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const OnboardingReplikaAppUsersStyles = styled(OnboardingPage)`
  background: #14111e !important;
  height: 100%;

  ion-content {
    position: relative;
    overflow: hidden;

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    .description {
      margin: 0 auto 26px;
    }

    .image-container {
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      line-height: 0;
      border-radius: 200px;
      overflow: hidden;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        aspect-ratio: 1/1;
        animation: planet-spin 30s linear infinite;
      }

      @keyframes planet-spin {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }

      @media screen and (min-width: 576px) {
        max-width: 500px;
        margin: 20px auto 0;
      }

      @media screen and (min-width: 768px) {
        max-width: 700px;
        margin: 30px auto 0;
      }
    }
  }
`;
